import { ExternalLinkIcon, SparklesIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { AssistantChat } from '@/components/assistant/assistant-chat';
import { useAssistantChat } from '@/components/assistant/assistant-chat-context';
import { Button } from '@/components/ui/button';
import { useEntityFeatures } from '@/hooks/use-entity-features';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle
} from '@/components/ui/sheet';

/**
 * Right-hand AI helper drawer. Conversation lives in AssistantChatProvider so
 * closing and reopening keeps the in-progress chat.
 */
export function AssistantDrawer() {
  const { drawerOpen, setDrawerOpen } = useAssistantChat();
  const { isEnabled } = useEntityFeatures();

  return (
    <Sheet open={drawerOpen && isEnabled('ai_tools')} onOpenChange={setDrawerOpen}>
      <SheetContent
        side="right"
        className="flex max-w-none w-full flex-col gap-0 p-0 sm:max-w-md md:max-w-lg"
      >
        <SheetHeader className="border-border space-y-1 border-b px-4 py-4 pr-12 text-left">
          <SheetTitle className="flex items-center gap-2 text-base">
            <SparklesIcon className="text-primary size-4" aria-hidden />
            Booking assistant
          </SheetTitle>
          <SheetDescription className="text-left text-xs sm:text-sm">
            Ask in natural language. Bookings only complete after you confirm a proposal.
          </SheetDescription>
          <div className="pt-1">
            <Button variant="link" size="sm" className="h-auto px-0" asChild>
              <Link to="/assistant" onClick={() => setDrawerOpen(false)}>
                Open full page
                <ExternalLinkIcon className="size-3.5" aria-hidden />
              </Link>
            </Button>
          </div>
        </SheetHeader>
        <div className="flex min-h-0 flex-1 flex-col p-4">
          <AssistantChat compact />
        </div>
      </SheetContent>
    </Sheet>
  );
}
